function initPharmacyLocator(container) {
  const SOURCE_URL = 'https://app.stosh.au/api/v1/store-front/partners/immunisation/list';
  if (!SOURCE_URL) return handleMessage("Error loading data", "error");
  const API_KEY = container.dataset.apikey;
  if (!API_KEY) return handleMessage("Error loading data", "error");
  
  let storeBranches = [];
  let autocomplete;
  let selectedPlace;
  const geocodeCache = {};
  
  // Pagination and caching
  let currentPage = 0;
  const itemsPerPage = 10;
  let sortedBranches = [];
  let lastLocationKey = null;
  let currentUserLocation = null;
  
  function getDistance(loc1, loc2) {
    const R = 6371;
    const dLat = ((loc2.lat - loc1.lat) * Math.PI) / 180;
    const dLng = ((loc2.lng - loc1.lng) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((loc1.lat * Math.PI) / 180) *
      Math.cos((loc2.lat * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  }
  
  function geocodeAddress(address) {
    if (geocodeCache[address]) {
      return Promise.resolve(geocodeCache[address]);
    }
  
    return new Promise((resolve, reject) => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          const coords = { lat: location.lat(), lng: location.lng() };
          geocodeCache[address] = coords;
          resolve(coords);
        } else {
          reject(`Geocode failed for "${address}": ${status}`);
        }
      });
    });
  }
  
  function setLoading(elId, loading = false) {
    const container = document.getElementById(elId);
    if (loading) {
      container.classList.add("is-loading");
      return;
    }
    container.classList.remove("is-loading");
  }
  
  async function loadBranchesAndGeocode() {
    setLoading("pharmacy-search", true);

    const response = await fetch(SOURCE_URL, { method: 'POST' });
    const list = await response.json();
    console.log({list})
    const geocoded = await Promise.all(
      list.data.map(async (branch) => {
        // If lat/lng exist, just return them
        if (branch.lat && branch.long) {
          return { ...branch, lat: Number(branch.lat), lng: Number(branch.long) };
        }

        // If address is missing, skip geocoding and return branch as-is
        if (!branch.address || branch.address.trim() === "") {
          console.warn(`Skipping geocoding for branch with missing address:`, branch);
          return { ...branch, lat: null, lng: null };
        }

        // Otherwise, geocode
        try {
          const coords = await geocodeAddress(branch.address);
          return { ...branch, ...coords };
        } catch (err) {
          console.error(`Failed to geocode branch: ${branch.address}`, err);
          return { ...branch, lat: null, lng: null };
        }
      })
    );

    storeBranches = geocoded;
    setLoading("pharmacy-search", false);
  }
  
  function handleMessage(errorMessage = false, type = "error") {
    if (errorMessage) {
      const alertAttributes = { message: errorMessage, type: type };
      const showAlertEvent = new CustomEvent("showAlert", { detail: alertAttributes });
      window.dispatchEvent(showAlertEvent);
    }
  }
  
  function showNearestStores(userLocation, reset = true) {
    const locationKey = `${userLocation.lat.toFixed(5)}_${userLocation.lng.toFixed(5)}`;
  
    if (reset || locationKey !== lastLocationKey) {
      currentPage = 0;
      currentUserLocation = userLocation;
      lastLocationKey = locationKey;
  
      sortedBranches = storeBranches
        .map((branch) => {
          const distance = getDistance(userLocation, { lat: branch.lat, lng: branch.lng });
          return { ...branch, distance };
        })
        .sort((a, b) => a.distance - b.distance);
  
      document.getElementById("store-list").innerHTML = "";
    }
  
    const start = currentPage * itemsPerPage;
    const end = start + itemsPerPage;
    const branchesToRender = sortedBranches.slice(start, end)
      .filter(branch => branch.id !== 9); // remove braeside (warehouse)
  
    renderBranches(branchesToRender);
    currentPage++;
  
    const loadMoreBtn = document.getElementById("load-more-btn");
    loadMoreBtn.style.display = currentPage * itemsPerPage < sortedBranches.length ? "block" : "none";
  }
  
  function renderBranches(branchList) {
    const list = document.getElementById("store-list");
    const fragment = document.createDocumentFragment();
    branchList.forEach((branch) => {
      const booking_link = branch.booking_link ? encodeURIComponent(branch.booking_link) : '';
      const name = encodeURIComponent(branch.name);
      let address = branch.address
      const parts = address.split(',');
      address = parts.length > 2 ? parts.slice(-2).join('<br />') : '';

      const div = document.createElement("div");
      div.innerHTML = `
        <div class="pharmacy-item pharmacy-search-card">
          <span class="pharmacy-item__distance">${branch.distance.toFixed(2)}km</span>
          <div class="pharmacy-item__info">
            ${branch.immunisation_service ? '<i class="fa-solid fa-check" style="color: #3e7f14;"></i>' : '<i class="fa-solid fa-xmark" style="color: red;"></i>'}
            <div>
              <span class="store-name"><strong>${branch.name}</strong></span><br />
              <span style="color: #3e7f14;"><strong>${branch.immunisation_service ? 'Available' : 'Not Available'}</strong></span>
            </div>
          </div>
          <div class="pharmacy-item__info">
            <i class="fa-solid fa-location-dot"></i>
            ${branch.address || '--'}<br/>
            ${address}
          </div>
          <div class="pharmacy-item__info">
            <i class="fa-solid fa-phone-flip"></i>
            ${branch.phone || '--' }
          </div>
          <div class="pharmacy-item__info">
            <i class="fa-regular fa-envelope"></i>
            ${branch.email || '--' }
          </div>
          ${booking_link ? `<a href="/pages/booking-now?name=${name}&booking_link=${booking_link}" target="_blank" class="pharmacy-btn book-now-link">Book now</a>` : ''}
        </div>`;
      fragment.appendChild(div);
    });
  
    list.appendChild(fragment);
  }
  
  function initAutocomplete() {
    const input = document.getElementById("search-input");
  
    autocomplete = new google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "au" },
      fields: ["geometry", "name"]
    });
  
    autocomplete.addListener("place_changed", () => {
      selectedPlace = autocomplete.getPlace();
      const userLocation = {
        lat: selectedPlace.geometry.location.lat(),
        lng: selectedPlace.geometry.location.lng()
      };
      showNearestStores(userLocation, true);
    });
  
    document.getElementById("search-btn").addEventListener("click", () => {
      if (!selectedPlace?.geometry) {
        handleMessage("Please select a valid location.", "info");
        return;
      }
  
      const userLocation = {
        lat: selectedPlace.geometry.location.lat(),
        lng: selectedPlace.geometry.location.lng()
      };
  
      showNearestStores(userLocation, true);
    });
  
    document.getElementById("load-more-btn").addEventListener("click", () => {
      if (currentUserLocation) {
        showNearestStores(currentUserLocation, false);
      }
    });
  }
  
  function loadGoogleMaps(apiKey) {
    return new Promise((resolve, reject) => {
      if (window.google && google.maps) {
        resolve();
        return;
      }
  
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=onGoogleMapsLoaded&loading=async`;
      script.async = true;
      script.defer = true;
  
      window.onGoogleMapsLoaded = () => resolve();
      script.onerror = reject;
  
      document.head.appendChild(script);
    });
  }
  
  async function initApp() {
    try {
      await loadGoogleMaps(API_KEY);
      await loadBranchesAndGeocode();
      initAutocomplete();
    } catch (err) {
      handleMessage("Error loading data or Google Maps.", "error");
    }
  }

  initApp();
}


// Run when the section first loads
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-section-type="pharmacy-locator"]').forEach(initPharmacyLocator);
});

// Run again if the section is reloaded via Shopify’s dynamic load (e.g. editor)
document.addEventListener('shopify:section:load', function(event) {
  const container = event.target;
  if (container && container.dataset.sectionType === "pharmacy-locator") {
    initPharmacyLocator(container);
  }
});